export default "__VITE_ASSET__BrOBiXO9__"